import { AxiosRequest } from '@infrastructure/axios';
import DomainModuleFactory from '@core/domain/index.module';
import UserSessionRespositoryFactory from '@infrastructure/persistance/user-session';

export default function onLogout(navigate) {
  return async function () {
    const SessionRepository = UserSessionRespositoryFactory.createLocalUserSessionRepository();
    AxiosRequest.clearCache();
    await SessionRepository.removeSession();
    DomainModuleFactory.clearInstances();
    navigate('/login');
  };
}
